import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader, ComponentFooter } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/type/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p><inlineCode parentName="p">{`Font`}</inlineCode>{` contains constants for `}<inlineCode parentName="p">{`UIFont`}</inlineCode>{` instances of each Thumbprint text style, as well as font variants and helper functions for use with Dynamic Type (see Accessibility below).`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`Thumbprint supports both static fonts and Dynamic Type–the iOS feature that enables users to choose their preferred text/content size. To get a `}<inlineCode parentName="p">{`UIFont`}</inlineCode>{` instance that will respect the user’s preferred content size, use one of the `}<inlineCode parentName="p">{`Font.dynamic(Text/Title)*`}</inlineCode>{` constants or the `}<inlineCode parentName="p">{`dynamicFont`}</inlineCode>{` property on a `}<inlineCode parentName="p">{`Font.TextStyle`}</inlineCode>{`. If you will be using this font instance with an `}<inlineCode parentName="p">{`NSAttributedString`}</inlineCode>{`, use the `}<inlineCode parentName="p">{`scaledFont(compatibleWith:)`}</inlineCode>{` function on `}<inlineCode parentName="p">{`Font.TextStyle`}</inlineCode>{` instead (otherwise the text size won’t scale as expected).`}</p>
    <h2>{`Public API`}</h2>
    <h3>{`Font`}</h3>
    <h4><inlineCode parentName="h4">{`public static let title1: UIFont`}</inlineCode></h4>
    <p>{`Static font with title 1 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-title1.png",
        "alt": "Title 1 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let title2: UIFont`}</inlineCode></h4>
    <p>{`Static font with title 2 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-title2.png",
        "alt": "Title 2 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let title3: UIFont`}</inlineCode></h4>
    <p>{`Static font with title 3 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-title3.png",
        "alt": "Title 3 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let title4: UIFont`}</inlineCode></h4>
    <p>{`Static font with title 4 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-title4.png",
        "alt": "Title 4 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let title5: UIFont`}</inlineCode></h4>
    <p>{`Static font with title 5 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-title5.png",
        "alt": "Title 5 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let title6: UIFont`}</inlineCode></h4>
    <p>{`Static font with title 6 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-title6.png",
        "alt": "Title 6 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let title7: UIFont`}</inlineCode></h4>
    <p>{`Static font with title 7 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-title7.png",
        "alt": "Title 7 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let title8: UIFont`}</inlineCode></h4>
    <p>{`Static font with title 8 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-title8.png",
        "alt": "Title 8 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let text1: UIFont`}</inlineCode></h4>
    <p>{`Static font with text 1 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-text1.png",
        "alt": "Text 1 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let text2: UIFont`}</inlineCode></h4>
    <p>{`Static font with text 2 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-text2.png",
        "alt": "Text 2 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let text3: UIFont`}</inlineCode></h4>
    <p>{`Static font with text 3 style.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-text3.png",
        "alt": "Text 3 text style"
      }}></img></p>
    <h4><inlineCode parentName="h4">{`public static let dynamicTitle1: UIFont`}</inlineCode></h4>
    <p>{`Font with title 1 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicTitle2: UIFont`}</inlineCode></h4>
    <p>{`Font with title 2 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicTitle3: UIFont`}</inlineCode></h4>
    <p>{`Font with title 3 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicTitle4: UIFont`}</inlineCode></h4>
    <p>{`Font with title 4 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicTitle5: UIFont`}</inlineCode></h4>
    <p>{`Font with title 5 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicTitle6: UIFont`}</inlineCode></h4>
    <p>{`Font with title 6 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicTitle7: UIFont`}</inlineCode></h4>
    <p>{`Font with title 7 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicTitle8: UIFont`}</inlineCode></h4>
    <p>{`Font with title 8 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicText1: UIFont`}</inlineCode></h4>
    <p>{`Font with text 1 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicText2: UIFont`}</inlineCode></h4>
    <p>{`Font with text 2 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static let dynamicText3: UIFont`}</inlineCode></h4>
    <p>{`Font with text 3 style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public static var traitCollectionOverrideForTesting: UITraitCollection?`}</inlineCode></h4>
    <p>{`Used by snapshot tests to forcefully apply the given trait collection. Do not use in application code.`}</p>
    <h4><inlineCode parentName="h4">{`static func loadCustomFonts()`}</inlineCode></h4>
    <p>{`Prepare fonts for use.`}</p>
    <h4><inlineCode parentName="h4">{`static func scaledValue(_ value: CGFloat, for style: TextStyle) -> CGFloat`}</inlineCode></h4>
    <p>{`Scale a floating point value by the same multiplier that is currently being used for Dynamic Type on the specific text style.`}</p>
    <h3>{`Font.TextStyle`}</h3>
    <h4><inlineCode parentName="h4">{`case title1, title2, title3, title4, title5, title6, title7, title8, text1, text2, text3`}</inlineCode></h4>
    <p>{`Enum cases for each Thumbprint text style.`}</p>
    <h4><inlineCode parentName="h4">{`public var font: UIFont`}</inlineCode></h4>
    <p>{`Static font with this text style.`}</p>
    <h4><inlineCode parentName="h4">{`public var dynamicFont: UIFont`}</inlineCode></h4>
    <p>{`Font with this text style that supports scaling for accessibility.`}</p>
    <h4><inlineCode parentName="h4">{`public func scaledFont(compatibleWith traitCollection: UITraitCollection) -> UIFont`}</inlineCode></h4>
    <p>{`Font with this text style that supports scaling for accessibility and is configured with a specific trait collection. When using attributed strings, `}<inlineCode parentName="p">{`UIContentSizeCategoryAdusting.adjustsFontForContentSizeCategory`}</inlineCode>{` does not work, and therefore fonts must be configured with a specific trait collection and updated any time the preferred content size category on the relevant view changes.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      